import { api } from './client.js';
import type { UserDto } from '../types.js';

export const authApi = {
  login: (username: string, password: string) =>
    api.post<{ user: UserDto }>('/auth/login', { username, password }),
  logout: () => api.post<void>('/auth/logout', {}),
  me: () => api.get<{ user: UserDto }>('/auth/me'),
};
